import React from 'react'
import FilterCard from '../../components/filter-card'
import { UserTypeEnum, UniversityTypeOptions, StatusOptions, CommonAllOption } from '../../utils/enums'

const UniversitiesFilter = ({ filters, onFilterChange, onFilterSubmit, onClearFilters, onRefresh, loading }) => {
  const fields = [
    {
      type: 'input',
      name: 'search',
      placeholder: 'UNIVERSITIES_FILTERS_SEARCH_PLACEHOLDER',
      icon: 'zmdi zmdi-search'
    },
    {
      type: 'select',
      name: 'city_id',
      placeholder: 'UNIVERSITIES_FILTERS_CITY_PLACEHOLDER',
      icon: 'zmdi zmdi-city',
      fetchUrl: 'cities',
      mapOption: (item) => {
        if (!item) return null
        const id = item.id ?? item.value
        const label = item.cityName || item.name || item.label
        if (id === undefined || id === null || !label) {
          return null
        }
        return {
          value: id.toString(),
          label: label.toString()
        }
      }
    },
    {
      type: 'input',
      name: 'province',
      placeholder: 'UNIVERSITIES_FILTERS_PROVINCE_PLACEHOLDER',
      icon: 'zmdi zmdi-pin'
    },
    {
      type: 'select',
      name: 'university_type',
      placeholder: 'UNIVERSITIES_FILTERS_TYPE_PLACEHOLDER',
      options: [CommonAllOption, ...UniversityTypeOptions]
    },
    {
      type: 'select',
      name: 'is_active',
      placeholder: 'UNIVERSITIES_FILTERS_STATUS_PLACEHOLDER',
      roleBased: true,
      roleAccess: UserTypeEnum.ADMIN,
      options: [CommonAllOption, ...StatusOptions]
    }
  ]

  const defaultFilters = {
    search: '',
    city_id: '',
    province: '',
    is_active: '',
    university_type: ''
  }

  return (
    <FilterCard
      filters={filters}
      onFilterChange={onFilterChange}
      onFilterSubmit={onFilterSubmit}
      onClearFilters={onClearFilters}
      onRefresh={onRefresh}
      loading={loading}
      title="UNIVERSITIES_FILTERS_TITLE"
      titleHide="UNIVERSITIES_FILTERS_HIDE"
      titleShow="UNIVERSITIES_FILTERS_SHOW"
      fields={fields}
      defaultFilters={defaultFilters}
      autoSubmitFields={['is_active', 'university_type']}
    />
  )
}

export default UniversitiesFilter

